import React from "react";
import { Circle } from "lucide-react";
import { Badge } from "../ui/badge";
import {
  MigrationStatus,
  MigrationStatusColors,
  MigrationStatusFileLabels,
  MigrationStatusIcons,
  MigrationStatusMigrationEntityLabels,
} from "../../models/MigrationStatus";

interface MigrationStatusChipProps {
  status: MigrationStatus;
  className?: string;
  isFile?: boolean;
}

const MigrationStatusChip: React.FC<MigrationStatusChipProps> = ({
  status,
  className,
  isFile,
}) => {
  const text = isFile
    ? (MigrationStatusFileLabels[status] ?? status)
    : (MigrationStatusMigrationEntityLabels[status] ?? status);

  const Icon = MigrationStatusIcons[status] ?? Circle;

  return (
    <Badge
      variant={MigrationStatusColors[status] ?? "neutral"}
      className={className}
    >
      <Icon className="size-3" />
      {text}
    </Badge>
  );
};

export default MigrationStatusChip;
